import {GlobalAnalyticsVariablesInterface, TrackReplaceSavedCreditCardInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackReplaceSavedCreditCardPayloadCase = (
  payload: any,
  passengerId: string,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackReplaceSavedCreditCardInterface => {
  const data = {
    eventType: payload.eventType,
    olciPassengerIds: payload.olciPassengerIds,
    passengerId,
    interaction: payload.interaction,
    paymentMethod: payload.paymentMethod
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
